import { render, staticRenderFns } from "./addDoctor.vue?vue&type=template&id=336224f6&scoped=true&"
import script from "./addDoctor.vue?vue&type=script&lang=js&"
export * from "./addDoctor.vue?vue&type=script&lang=js&"
import style0 from "./addDoctor.vue?vue&type=style&index=0&id=336224f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336224f6",
  null
  
)

export default component.exports